// Instructions on how to import other JS files into this one.
// https://babeljs.io/learn-es2015/#modules
// http://exploringjs.com/es6/ch_modules.html
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export

import Vue from 'vue'
import VueCookie from 'vue-cookie'
import SocialSharing from 'vue-social-sharing'
import VModal from 'vue-js-modal' // https://www.npmjs.com/package/vue-js-modal
import PublicationFilters from './_vue/PublicationFilters'
import PageHeader from './_vue/PageHeader'
import NewsletterButton from './_vue/NewsletterButton'
import ModalOpen from './_vue/ModalOpen'
import AttorneyTabs from './_vue/AttorneyTabs'
import GdprBanner from './_vue/GdprBanner'
import 'babel-polyfill'
import GLightbox from 'glightbox'

import * as nav from './nav'
import * as newsletterModuleTabs from './newsletter-module-tabs'
import * as publicationTools from './publication-tools'
import * as carousel from './carousel'


Vue.use(SocialSharing)
Vue.use(VModal)
Vue.use(GLightbox)
Vue.use(VueCookie)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  mounted() {
    nav.initialize()
    carousel.initialize()
    newsletterModuleTabs.initialize()
    publicationTools.initialize()
    const lightbox = GLightbox({
      selector: '.video',
      touchNavigation: true,
      loop: false,
      autoplayVideos: true,
      closeButton: true,
      plyr: {
        // both plyr CSS and JS URLs are required here otherwise "Inject videos api error"
        css: 'https://cdn.plyr.io/3.6.4/plyr.css', // default value
        js: 'https://plyr-js.netlify.app/plyr.polyfilled.min.js', // fixed polyfilled version
        ratio: '16:9', // required otherwise error split undefined
      }
    });
    const allLightboxTriggers = document.querySelectorAll('.lightbox-trigger')
    if (allLightboxTriggers) {
      allLightboxTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault()
          let targetHref = this.getAttribute('href')
          lightbox.setElements([{'href': targetHref}])
          lightbox.open()
        })
      })
    }
  },
  components: {
    'publication-filters': PublicationFilters,
    'page-header': PageHeader,
    'newsletter-button': NewsletterButton,
    'modal-open': ModalOpen,
    'attorney-tabs': AttorneyTabs,
    'gdpr-banner': GdprBanner
  }
})
